import React from "react";
import PropTypes from "prop-types";
import Datetime from "./react-datetime";
import "./index.css";
import Icon from "storybookComponents/Icon";
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import moment from 'moment';



var yesterday = moment().subtract(1, 'day');
var valid = function (current) {
  return current.isAfter(yesterday);
};


const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const iconStyle = {
  position: "absolute",
  top: 8,
  right: 8
}

const Picker = React.memo((props) => {

  let [value, setValue] = React.useState(props.defaultValue);

  const parseData = (data) => {
    let value = data.value;
    let dateTime = value.split(" ");
    if (dateTime.length === 3) {
      let date = dateTime[0].split("/");
      data.value = date[1] + " " + months[parseInt(dateTime[0]) - 1] + " " + date[2] + ", " + dateTime[1] + dateTime[2];
    } else if (dateTime.length === 1 && data.value) {
      let date = dateTime[0].split("/");
      data.value = date[1] + " " + months[parseInt(dateTime[0]) - 1] + " " + date[2];
    }
    return data;
  }

  const { type, icon, format, ...rest } = props;

  const handleChange = e => {
    setValue(e._d)
    props.handleChange(e._d)
  };

  const moveUp = () => {
    setTimeout(() => {
      window.scrollTo(0, document.body.scrollHeight);
    }, 500)
  }

  return (
    <div style={{ position: "absolute", zIndex: 5 }}>

      <Datetime
        dateFormat={type === "date" || type === "datetime"}
        timeFormat={type === "time" || type === "datetime"}
        onChange={handleChange}
        value={value}
        isValidDate={props.allowPast ? () => { return true } : valid}
        renderInput={(data) => {
          return (<>
            {
              icon ?
                <TextField
                  {...parseData(data)}
                  id="input-with-icon-textfield"
                  label={rest.placeholder}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Icon size="sm" type="icon-calendar-2" />
                      </InputAdornment>
                    ),
                    readOnly: true
                  }}
                  {...rest}
                  autoComplete="off"
                  onFocus={moveUp}
                />
                :
                <input
                  {...data}
                  type="text"
                  variant="top"
                  no_label={false}
                  required={false}
                  multiline={false}
                  readOnly
                  {...rest}
                  id="eventDateTimeInput"
                  autoComplete="off"
                />
            }
          </>)
        }}
      />
    </div>
  )
}
)

Picker.propTypes = {
  type: PropTypes.oneOf(["date", "time", "datetime", "timeframe"]).isRequired,
  handleChange: PropTypes.func,
};

Picker.defaultProps = {
  type: "date"
};

export default Picker;